module.exports = __webpack_public_path__ + "fonts/NotoSansLao-Regular.a7fcff3.eot";